import { Component, HostListener, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../../environments/environment';
import { Helper } from '../../core/services/helper';

@Component({
  selector: 'app-header',
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  private readonly document = inject(DOCUMENT);
  private readonly helperService = inject(Helper);

  environment = environment;
  header = environment.HeaderConfig;
  booking: any = environment.BookingConfig;

  navigation: any[] = [];

  isScrolled = false;

  constructor() {
    this.navigation = this.helperService.getNavItems();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 50;
  }

 menuOpen = false;

toggleMenu(): void {
  this.menuOpen = !this.menuOpen;

  if (this.menuOpen) {
    this.document.body.classList.add('menu-open');
  } else {
    this.document.body.classList.remove('menu-open');
  }
}

closeMenu(): void {
  this.menuOpen = false;
  this.document.body.classList.remove('menu-open');
}
}
